import Vue from "vue";
export const SongDataInfo = new Vue();
